module.exports = __webpack_public_path__ + "static/img/1_9_3.f7214ca1.jpg";